export default "__VITE_ASSET__oC$dnA2q__"